// 箱单发票列表 일괄 업로드 — 올린 파일(产地证 核对件·正本 / 提单BL)이 어느 행(기록)·몇 번째 产地证 인지 맞춘다(2026-10-07 YZY).
// 순수 함수 모듈(브라우저·node 공용, import 없음). 화면은 InvoiceRecordList.vue.
//
// 실제로 올라온 파일 이름(운영 DB·딩톡, 2026-10-07 조사):
//   产地证 核对件 「RUBY0930-P01-0930-41-1-确认件(1).pdf」 = 产地证 송장번호(RUBY0930-P01~0930-41-1)의 「~」 를 「-」 로
//   产地证 正本   「INFO0930-P01-INFO0930-P03.pdf」         = 첫 托盘号-마지막 托盘号
//   提单BL        「GSPC26064E803A6 飞运.pdf」               = BL 번호뿐 → 내용(唛头 = 托盘号 범위, 收货人)으로 맞춘다
// 그래서 파일 이름 + AI 판독값(产地证 송장번호·收货人 / BL 번호·唛头·收货人)을 한 글로 이어 놓고 아래 순서로 찾는다.
//   ① 정확한 번호 — 产地证 송장번호(장 번호 -1·-2 까지) / 이미 올린 BL 번호  → 행·장이 바로 정해진다
//   ② 托盘号 범위 — 행의 첫·마지막 托盘号(散货 는 箱号)가 글에 있으면 점수. 마지막 번호는 머리(RUBY)를 뗀 꼴도 본다(송장번호가 그렇다)
//   ③ 동점이면 收货人 이 그 행 화주(수입자)와 같은 것만 남긴다. 그래도 둘 이상이면 못 맞춘 것으로 둔다(사람이 고른다)
// 产地证 이 여러 장인 행에서 장 번호가 안 정해지면 품목 대조(cooScore)가 가장 잘 맞는 장을 고른다.

function text(v) {
  if (v === null || v === undefined) return ''
  return String(v).replace(/\r/g, '').trim()
}
// 경계까지 보는 비교용 글 — 대문자, 영숫자·「散货」 밖은 전부 「-」. 앞뒤에도 「-」 를 붙여 「-RUBY0930-41-」 꼴로 찾는다
// (그래야 RUBY0930-4 가 RUBY0930-41 안에서, CO 「-1」 이 「-11」 안에서 잘못 잡히지 않는다)
export function tokenText(s) {
  return '-' + text(s).toUpperCase().replace(/[^A-Z0-9散货]+/g, '-').replace(/^-+|-+$/g, '') + '-'
}
function has(hay, s) {
  const t = tokenText(s)
  return t.length > 2 && hay.includes(t)
}
const isLoose = id => /散货/.test(text(id))
const headless = id => text(id).replace(/^[A-Za-z]+/, '')

// 행의 식별자 — ids = 托盘号 전부 + 散货 箱号, ends = 양 끝 짝 둘:
//   ① 产地证 송장번호·唛头 꼴 — 托盘号(散货 빼고, 저장 순서) 뒤에 散货 箱号(정렬)  예) DEAR0930-01 ~ FU092825
//   ② 托盘号 목록 그대로(散货 托盘号 포함)                                          예) RUBY1007-45 ~ RUBY1007-KD散货
export function recordIdents(r) {
  const ps = (r && r.pallets && r.pallets.length) ? r.pallets : ((r && r.palletIds) || []).map(id => ({ id }))
  const all = ps.map(p => text(p.id)).filter(Boolean)
  const plts = ps.filter(p => !(p.kind === 'BOX' || isLoose(p.id))).map(p => text(p.id)).filter(Boolean)
  const codes = []
  ps.filter(p => p.kind === 'BOX' || isLoose(p.id)).forEach(p => {
    (p.boxCodes || []).concat((p.boxes || []).map(b => b && b.code)).forEach(c => {
      text(c).split(/[,\s]+/).filter(Boolean).forEach(x => { if (!codes.includes(x)) codes.push(x) })
    })
  })
  codes.sort()
  const mark = plts.concat(codes)
  const ends = [mark, all].filter(a => a.length).map(a => [a[0], a[a.length - 1]])
  return { ids: [...new Set(all.concat(codes))], ends }
}

// 파일 이름 + 판독값 → 찾을 글 하나
export function docHay(kind, name, x) {
  const e = x || {}
  const parts = [String(name || '').replace(/\.[A-Za-z0-9]{2,5}$/, '')]
  if (kind === 'bl') parts.push(e.blNo, e.marks)
  else parts.push(e.invoiceNo, e.certificateNo)
  return tokenText(parts.filter(Boolean).join(' '))
}

/**
 * @param {'coo'|'bl'} kind
 * @param {Array} records   목록 기록들(list API — pallets·coo·bl·info 포함)
 * @param {{name, extracted}} doc
 * @param {{consigneeOk?: (record, consigneeText) => boolean, cooScore?: (record, cooFile, extracted) => number}} opt
 *   cooScore = 작을수록 잘 맞음(불일치 개수)
 * @returns {{recordId, no, by, score, candidates}}  by: 'invoiceNo' | 'blNo' | 'pallet' | '' (못 맞춤)
 */
export function matchDoc(kind, records, doc, opt) {
  const o = opt || {}
  const x = (doc && doc.extracted) || {}
  const hay = docHay(kind, doc && doc.name, x)
  const none = { recordId: '', no: null, by: '', score: 0, candidates: [] }
  const list = (records || []).filter(Boolean)

  // ① 정확한 번호
  if (kind === 'bl') {
    const hits = list.filter(r => r.bl && r.bl.no && has(hay, r.bl.no))
    if (hits.length === 1) return { recordId: hits[0]._id, no: null, by: 'blNo', score: 100, candidates: [hits[0]._id] }
  } else {
    const hits = []
    list.forEach(r => ((r.coo && r.coo.files) || []).forEach(f => {
      if (f.invoiceNo && has(hay, f.invoiceNo)) hits.push({ r, f })
    }))
    // 같은 번호가 여러 행에 있으면(같은 托盘 을 다시 묶은 옛 기록) 아래 ②·③ 으로 가린다
    const rs = [...new Set(hits.map(h => h.r._id))]
    if (rs.length === 1) {
      const fs = hits.filter(h => h.r._id === rs[0])
      const f = fs.length === 1 ? fs[0].f : pickCoo(fs[0].r, fs.map(h => h.f), x, o)
      return { recordId: rs[0], no: f ? f.no : null, by: 'invoiceNo', score: 100, candidates: rs }
    }
  }

  // ② 托盘号 범위
  const scored = list.map(r => {
    const { ids, ends } = recordIdents(r)
    if (!ids.length) return { r, score: 0 }
    const hits = ids.filter(id => has(hay, id)).length
    // 양 끝 짝마다 — 첫 번호, 마지막 번호(머리 뗀 꼴은 첫 번호가 맞았을 때만).
    // 한 개짜리 행은 양 끝이 같아 1 점 덜 준다 — 「A~B」 글에서 A 하나짜리 행이 A~B 행과 비기지 않게
    const endScore = Math.max(...ends.map(([a, b]) => {
      const first = has(hay, a)
      if (a === b) return first ? 19 : 0
      const last = has(hay, b) || (first && has(hay, headless(b)))
      return (first ? 10 : 0) + (last ? 10 : 0)
    }))
    return { r, score: endScore + hits }
  }).filter(s => s.score >= 10) // 양 끝 중 하나는 맞아야 한다
  if (!scored.length) return none
  const top = Math.max(...scored.map(s => s.score))
  let best = scored.filter(s => s.score === top)
  // ③ 收货人
  if (best.length > 1 && o.consigneeOk && text(x.consignee)) {
    const same = best.filter(s => o.consigneeOk(s.r, x.consignee))
    if (same.length) best = same
  }
  if (best.length !== 1) return Object.assign({}, none, { score: top, candidates: best.map(s => s.r._id) })
  const r = best[0].r
  let no = null
  if (kind !== 'bl') {
    const f = pickCoo(r, (r.coo && r.coo.files) || [], x, o, hay)
    no = f ? f.no : null
  }
  return { recordId: r._id, no, by: 'pallet', score: top, candidates: [r._id] }
}

// 행 안에서 产地证 장 고르기 — 한 장이면 그것, 송장번호 끝 「-N」 이 그 장이면 그것, 아니면 품목 대조가 가장 잘 맞는 장
function pickCoo(r, files, x, o, hay) {
  if (!files.length) return null
  if (files.length === 1) return files[0]
  if (hay) {
    const byNo = files.filter(f => f.invoiceNo && has(hay, f.invoiceNo))
    if (byNo.length === 1) return byNo[0]
  }
  if (o.cooScore && x && Array.isArray(x.items) && x.items.length) {
    const s = files.map(f => ({ f, d: o.cooScore(r, f, x) })).sort((a, b) => a.d - b.d)
    if (s.length && (s.length === 1 || s[0].d < s[1].d)) return s[0].f
  }
  return null
}

export default { tokenText, recordIdents, docHay, matchDoc }
